import * as React from "react";
import { Container, Col, Row } from 'react-bootstrap';
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import LazyLoad from "react-lazy-load";

const OurClients = ({
  title = "Our <span class='text-primary'>clients</span>",
  description = "Peerbits has helped global enterprises grow by delivering top-quality software aligning an expert team of dedicated offshore developers.",
  sectionClass = 'bg-light',
}) => {

  // const ClientsLogo1 = '../images/clients/company-profile-clients-logo1.png';
  // const ClientsLogo17 = '../images/clients/company-profile-clients-logo17.png';
  // const ClientsLogo18 = '../images/clients/company-profile-clients-logo18.png';
  // const ClientsLogo19 = '../images/clients/company-profile-clients-logo19.png';
  // const ClientsLogo21 = '../images/clients/company-profile-clients-logo21.png';
  // const ClientsLogo22 = '../images/clients/company-profile-clients-logo22.png';
  // const ClientsLogo23 = '../images/clients/company-profile-clients-logo23.png';
  // const ClientsLogo26 = '../images/clients/company-profile-clients-logo26.png';


  const ClientsLogo7 = '../images/clients/company-profile-clients-logo7.png';
  const ClientsLogo2 = '../images/clients/company-profile-clients-logo2.png';
  const ClientsLogo8 = '../images/clients/company-profile-clients-logo8.png';
  const ClientsLogo14 = '../images/clients/company-profile-clients-logo14.png';
  const ClientsLogo32 = '../images/clients/company-profile-clients-logo32.png';
  const ClientsLogo37 = '../images/clients/company-profile-clients-logo37.png';
  const ClientsLogo41 = '../images/clients/company-profile-clients-logo41.png';
  const ClientsLogo43 = '../images/clients/company-profile-clients-logo43.png';


  return (
    <section className={`section ${sectionClass}`}>
      <Container className="py-5">
        <div className="mb-4 pb-1">
          <h2 className="mb-4" dangerouslySetInnerHTML={{ __html: title }} />
          <p className="max-width-950 lead">{description}</p>
        </div>
        <div className="mb-4">
          <div className="d-none d-lg-block">
            <Row className="g-4 our-clients-logo" xs={1} sm={2} lg={4}>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo43} alt="company-profile-clients-logo34" width={197} height={50} />
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo41} alt="company-profile-clients-logo40" width={74} height={74} />
                </div>

              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo37} alt="company-profile-clients-logo32" width={155} height={30} />
                </div>

              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo32} alt="company-profile-clients-logo39" width={187} height={70} />
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo7} alt="company-profile-clients-logo5" width={135} height={70} />
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo2} alt="company-profile-clients-logo2" width={165} height={32} />
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo8} alt="company-profile-clients-logo6" width={232} height={38} />
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo14} alt="company-profile-clients-logo8" width={200} height={22} />
                </div>
              </Col>










              {/*               
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo1} alt="company-profile-clients-logo1" width={102} height={70} />
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo22} alt="company-profile-clients-logo12" width={144} height={55} />
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo21} alt="company-profile-clients-logo11" width={204} height={55} />
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo23} alt="company-profile-clients-logo13" width={182} height={55} />
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo19} alt="company-profile-clients-logo11" width={204} height={55} />
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo26} alt="company-profile-clients-logo27" width={176} height={42} />
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo18} alt="company-profile-clients-logo37" width={211} height={46} />
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                  <StaticImage loading="lazy" src={ClientsLogo17} alt="company-profile-clients-logo23" width={228} height={44} />
                </div>
              </Col> */}
            </Row>
          </div>
          <div className="d-block d-lg-none">
            <LazyLoad>
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                slidesPerView={1}
                navigation={false}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  576: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                }}
                className="our-clients-logo light-slider"
              >
                <SwiperSlide>
                  <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                    <StaticImage loading="lazy" src={ClientsLogo7} alt="company-profile-clients-logo5" width={135} height={70} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                    <StaticImage loading="lazy" src={ClientsLogo2} alt="company-profile-clients-logo2" width={165} height={32} />                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                    <StaticImage loading="lazy" src={ClientsLogo8} alt="company-profile-clients-logo6" width={232} height={38} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                    <StaticImage loading="lazy" src={ClientsLogo14} alt="company-profile-clients-logo8" width={200} height={22} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                    <StaticImage loading="lazy" src={ClientsLogo32} alt="company-profile-clients-logo39" width={187} height={70} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                    <StaticImage loading="lazy" src={ClientsLogo37} alt="company-profile-clients-logo32" width={155} height={30} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                    <StaticImage loading="lazy" src={ClientsLogo41} alt="company-profile-clients-logo40" width={74} height={74} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="dark-box-1 equal-height justify-content-center align-items-center d-flex bg-transparent">
                    <StaticImage loading="lazy" src={ClientsLogo43} alt="company-profile-clients-logo34" width={197} height={50} />
                  </div>
                </SwiperSlide>
              </Swiper>
            </LazyLoad>
          </div>
        </div>
        <div className="text-center mt-0 mt-lg-4 pt-0 pt-lg-4">
          <Link to="/our-clients.html" className="btn btn-link">
            <span>View more clients</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
          </Link>
        </div>
      </Container>
    </section>
  );
}

export default OurClients;
